// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1rKyT","content":"Consent_content__N9fZo","footer":"Consent_footer__1Nyo3"};